export default "__VITE_PUBLIC_ASSET__7c1a62c8__"